const page = 'events';

export default [
    {
        path: '/core/' + page,
        name: `${page}-main`,
        exact: true,
        component: () => import('@/pages/core/events/Index'),
        meta: {
            auth: true,
            permission: ['core.events.access'],
            title: 'Events',
            prefix: `${page}-main`,
            nimbusPageType: 'nav-landing-page'
        },
        children: [
            {
                path: `/core/events/event-statuses`,
                name: `${page}-events-type-status`,
                exact: true,
                component: () => import('@/pages/core/events/event_statuses/EventStatusesMain'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-type-status.access'],
                    title: 'Event Type Status',
                    prefix: `${page}-event-statuses`,
                },
            },
            {
                path: `/core/events/event-template-field-types`,
                name: `${page}-event-template-field-types`,
                exact: true,
                component: () => import('@/pages/core/events/event_template_field_types/EventTemplateFieldTypesMain'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-templates-field-types.access'],
                    title: 'Event Template Field Types',
                    prefix: `${page}-event-template-field-types`,
                },
            },
            {
                path: `/core/events/event-template-fields`,
                name: `${page}-event-template-fields`,
                exact: true,
                component: () => import('@/pages/core/events/event_template_fields/EventTemplateFieldsMain.vue'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-templates-fields.access'],
                    title: 'Event Template Fields',
                    prefix: `${page}-event-template-fields`,
                },
            },
            {
                path: `/core/events/event-templates-core`,
                name: `${page}-event-templates-core`,
                exact: true,
                component: () => import('@/pages/core/events/event_templates/CoreEventTemplatesMain.vue'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-templates.access'],
                    title: 'Event Templates',
                    prefix: `${page}-event-templates-core`,
                },
            },
            {
                path: `/core/events/events-event-type-config`,
                name: `${page}-event-type-config`,
                exact: true,
                component: () => import('@/pages/core/events/event_type_config/EventTypeConfigMain.vue'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-type-mapping.access'],
                    title: 'Event Type Config',
                    prefix: `${page}-event-type-config`,
                },
            },
            {
                path: `/core/events/events-types`,
                name: `${page}-event-types`,
                exact: true,
                component: () => import('@/pages/core/events/event_types/EventTypeMain.vue'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-types.access'],
                    title: 'Event Types',
                    prefix: `${page}-event-types`,
                },
            },

        ]
    },

];
